<div class="row" *ngIf="!sessionService.isAuthenticated()">
    <div class="col-lg-1"></div>
    <div class="col-md-12 col-lg-5">
        <div class="row justify-content-lg-center white-panel">
            <div class="col-md-12 col-lg-11">
                <aside class="px-3 pb-4 text-start" aria-labelledby="login-promotion-heading">
                    <p class="mb-2 text-center">
                        <span class="login-promotion-panel__eyebrow badge rounded-pill text-uppercase">School Administrators</span>
                    </p>
                    <h2 class="login-promotion-panel__heading fs-3 fw-semibold mb-4 text-center" id="login-promotion-heading">Did You Know?</h2>
                    <ul class="list-group list-group-flush mb-4">
                        <li class="list-group-item px-0">
                            <span class="login-promotion-panel__item-title d-block fw-semibold">Track Volunteers in Comply</span>
                            <span class="d-block small">Keep volunteer clearances and other requirements organized with the Volunteer Module</span>
                        </li>
                        <li class="list-group-item px-0">
                            <span class="login-promotion-panel__item-title d-block fw-semibold">New Templates Available</span>
                            <span class="d-block small">Browse our catalog of template items, including new Act 55 trainings for <span class="text-nowrap">Modules 8-11</span></span>
                        </li>
                        <li class="list-group-item px-0">
                            <span class="login-promotion-panel__item-title d-block fw-semibold">Track Educator Flex Hours</span>
                            <span class="d-block small">Monitor educator completion of flexible professional development time<span class="text-nowrap"> - <a href="https://edulink.freshdesk.com/support/solutions/articles/29000050072-how-to-track-flex-hours-in-comply-" target="_blank" rel="noopener noreferrer">Learn how<span class="visually-hidden"> (opens in a new tab)</span></a></span></span>
                        </li>
                        <li class="list-group-item px-0">
                            <span class="login-promotion-panel__item-title d-block fw-semibold">Revamped Tutorial for Basic Users</span>
                            <span class="d-block small">Get up to speed on Comply with the refreshed video overview for Basic Users<span class="text-nowrap"> - <a href="https://www.youtube.com/watch?v=kScTeeIN-ls" target="_blank" rel="noopener noreferrer">Watch now<span class="visually-hidden"> (opens in a new tab)</span></a></span></span>
                        </li>
                    </ul>
                    <div class="alert alert-success d-flex gap-3 mb-0">
                        <i class="fas fa-comments fa-lg mt-1" aria-hidden="true"></i>
                        <div>
                            <strong class="d-block fw-semibold">Want to Learn More?</strong>
                            Contact your support representative for more information.
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    </div>
    <div class="col-md-12 col-lg-5">
        <div class="row justify-content-lg-center white-panel">
            <div class="col-md-12 col-lg-10">
                <ui-view name="login-content"></ui-view>
            </div>
        </div>
    </div>
    <div class="col-lg-1"></div>
</div>
